/* ============================================================
   OLD MONEY — CENTRAL IMAGE CONFIGURATION
   ------------------------------------------------------------
   Markup never contains a URL — it contains <img data-img="key">
   and script.js hydrates it from the table below.

   On Shopify these are the FALLBACK: where the store has the product,
   shopify/theme/snippets/scent-image.liquid prints the product's own image
   instead, and the keys below are only what a scent falls back to when its
   product is missing (a fresh install, or a scent not published yet). The
   store numbers a product's images the way these files are numbered, so -1,
   -2 and -3 here and images 1, 2 and 3 on the product are the same frames.

   These are the brand's REAL photographs, salvaged from the
   earlier build (see NOTES.md).

   ⚠ THE PHOTOGRAPHY HAS TYPE BAKED INTO THE PIXELS.
   Headlines, note lists and claims are part of the image, so a
   crop that changes the aspect ratio slices their words in half.
   Each entry records its native aspect. Put an image in a box
   that matches it — never crop harder to make it fit.

       MIXED pack shots — 2:3 (1024×1536) for royal-rupee, pound-power,
             lusty-london, milan-mist, mumbai-meeraki; 1:1 (1080/1200) for
             dollar-dream, europhoria, berlin-bliss
       1:1   every styled (-2) frame   (1200 × 1200)
       3:2   lifestyle-1                (1600 × 1066)
       16:9  editorial / banner         brand headlines inside
       2.77:1 scene-*                   ultra-wide strips only

   Frame numbering is consistent across all eight scents:
       -1 pack shot      -2 styled scene / note list
       -3 -4 box contents and certifications
       -5 "For …" tagline   -6 the 8–10 hours claim
       -7 "Crafted for Him & Her"

   Keys ending in a number keep their old names so product.html
   continues to resolve without edits.
   ============================================================ */

(function (global) {
  'use strict';

  /* On Shopify every file sits flat in the theme's assets folder, so all three
     prefixes are the same URL. layout/theme.liquid sets OM_ASSET_BASE. */
  var R = global.OM_ASSET_BASE || 'assets/';   /* real photography */
  var P = R;                                   /* generated plates */
  var Q = R;                                   /* product frames */

  /* A 600px crop of every -1 and -2 frame has been sitting in assets/img/p/
     since the import — 36 files, none of them ever requested. hydrateImage set
     .src to the full photograph and stopped, so a 1024x1536 carton was being
     fetched and decoded to paint a 135px picker tile on the notes page: about
     6 MB of bitmap per image held in memory to draw a thumbnail.

     `small` is the 600w file and `w` is the full file's real width in pixels,
     measured off the files themselves — a srcset cannot choose sensibly
     without it. Frames with no -600 sibling (-3 scenes, -5 campaign) carry
     neither key and hydrateImage leaves them on a plain src. */
  function small(src) { return src.replace(/\.webp$/, '-600.webp'); }

  function scent(handle, name, aspect, frontW) {
    var f = Q + 'old-money-' + handle + '-1.webp';
    var t = Q + 'old-money-' + handle + '-2.webp';
    return {
      /* front frames are 2:3 for five scents and 1:1 for three, so the card
         frame is square with object-fit:contain and crops neither. */
      front: { src: f, small: small(f), w: frontW, alt: name + ' eau de parfum, bottle and carton', aspect: aspect || 'mixed 2:3 / 1:1' },
      styled:{ src: t, small: small(t), w: 1200, alt: name + ', styled with its note list', aspect: '1:1' },
      /* -5 is the campaign frame: the city or currency artwork with the
         bottle in it, and the scent's tagline set into the pixels. 1:1, so
         a square card shows it whole. */
      campaign:{ src: Q + 'old-money-' + handle + '-5.webp', alt: name + ' campaign', aspect: '1:1' }
    };
  }

  var RR = scent('royal-rupee','Royal Rupee',null,1024),
      DD = scent('dollar-dream','Dollar Dream',null,1080),
      PP = scent('pound-power','Pound Power',null,1024),
      EU = scent('europhoria','Europhoria',null,1200),
      LL = scent('lusty-london','Lusty London',null,1024),
      BB = scent('berlin-bliss','Berlin Bliss',null,1200),
      MM = scent('milan-mist','Milan Mist',null,1024),
      MK = scent('mumbai-meeraki','Mumbai Meeraki',null,1024);

  function pack(handle, name, w) {
    var src = Q + 'travel-packs-' + handle + '-1.webp';
    return { src: src, small: small(src), w: w, alt: name + ' travel pack, 15 ML', aspect: '2:3' };
  }

  /* -3 is the styled scene for a travel pack. Unlike the cartons these carry
     NO baked-in type, so they are the one set of images it is safe to crop —
     which is why the pack tiles use object-fit:cover and go full bleed. */
  function packScene(handle, name) {
    var src = Q + 'travel-packs-' + handle + '-3.webp';
    return { src: src, small: small(src), w: 1200, alt: name + ' travel pack', aspect: 'varies, no type' };
  }

  global.OM_IMAGES = {

    /* ---------- hero: portrait frames only, so no headline is cropped ---------- */
    hero:       { src: R + 'lifestyle-2.webp', alt: 'Old Money campaign portrait', aspect: '2:3' },
    heroMobile: { src: R + 'lifestyle-3.webp', alt: 'Old Money campaign, vertical crop', aspect: '2:3' },

    /* ---------- the eight scents ---------- */
    /* `productN` is the clean pack shot, `productNAlt` the styled scene,
       `productNCampaign` the city/currency artwork. Cards show the campaign
       at rest and cross-fade to the pack shot on hover. */
    product1: RR.front, product1Alt: RR.styled, product1Campaign: RR.campaign,
    product2: DD.front, product2Alt: DD.styled, product2Campaign: DD.campaign,
    product3: PP.front, product3Alt: PP.styled, product3Campaign: PP.campaign,
    product4: EU.front, product4Alt: EU.styled, product4Campaign: EU.campaign,
    product5: LL.front, product5Alt: LL.styled, product5Campaign: LL.campaign,
    product6: BB.front, product6Alt: BB.styled, product6Campaign: BB.campaign,
    product7: MM.front, product7Alt: MM.styled, product7Campaign: MM.campaign,
    product8: MK.front, product8Alt: MK.styled, product8Campaign: MK.campaign,

    /* ---------- travel packs, 20 ML, ₹350 ---------- */
    packRoyalRupee:    pack('royal-rupee','Royal Rupee',1200),
    /* their store misspells this handle ("trave-packs"); the file keeps the typo */
    packDollarDream:   { src: Q + 'trave-packs-dollar-dream-1.webp', small: Q + 'trave-packs-dollar-dream-1-600.webp', w: 1200, alt: 'Dollar Dream travel pack, 15 ML', aspect: '2:3' },
    packPoundPower:    pack('pound-power','Pound Power',1200),
    packEurophoria:    pack('europhoria','Europhoria',1080),
    packLustyLondon:   pack('lusty-london','Lusty London',1080),
    packBerlinBliss:   pack('berlin-bliss','Berlin Bliss',1080),
    packMilanMist:     pack('milan-mist','Milan Mist',1080),
    packMumbaiMeeraki: pack('mumbai-meeraki','Mumbai Meeraki',1200),

    packRoyalRupeeScene:    packScene('royal-rupee','Royal Rupee'),
    packDollarDreamScene:   { src: Q + 'trave-packs-dollar-dream-3.webp', small: Q + 'trave-packs-dollar-dream-3-600.webp', w: 1200, alt: 'Dollar Dream travel pack', aspect: 'varies, no type' },
    packPoundPowerScene:    packScene('pound-power','Pound Power'),
    packEurophoriaScene:    packScene('europhoria','Europhoria'),
    packLustyLondonScene:   packScene('lusty-london','Lusty London'),
    packBerlinBlissScene:   packScene('berlin-bliss','Berlin Bliss'),
    packMilanMistScene:     packScene('milan-mist','Milan Mist'),
    packMumbaiMeerakiScene: packScene('mumbai-meeraki','Mumbai Meeraki'),

    /* ---------- editorial — 16:9, brand headline inside the pixels ---------- */
    editorial:          { src: R + 'editorial-1.webp', alt: 'Old Money campaign', aspect: '16:9' },
    editorialSecondary: { src: R + 'editorial-2.webp', alt: 'Old Money campaign', aspect: '16:9' },
    bannerWide:         { src: R + 'banner-wide.webp', alt: 'The Old Money range', aspect: '16:9' },

    /* ---------- ultra-wide strips (2.77:1) — thin bands only ---------- */
    sceneLondon: { src: R + 'scene-london.webp', alt: 'Lusty London campaign strip', aspect: '2.77:1' },
    sceneDream:  { src: R + 'scene-dream.webp',  alt: 'Dollar Dream campaign strip', aspect: '2.77:1' },

    /* ---------- lifestyle ---------- */
    campaignMen:    { src: R + 'lifestyle-1.webp', alt: 'Old Money lifestyle', aspect: '3:2' },
    campaignWomen:  { src: R + 'lifestyle-2.webp', alt: 'Old Money lifestyle', aspect: '2:3' },
    campaignCouple: { src: R + 'lifestyle-3.webp', alt: 'Old Money lifestyle', aspect: '2:3' },
    logoMark:       { src: R + 'logo-mark.webp',   alt: 'Old Money',            aspect: '2.53:1' },

    /* ---------- gifting ---------- */
    giftbox: { src: Q + 'rich-and-rare-1.webp', alt: 'Rich & Rare gift set, four 15 ML bottles', aspect: '2:3' },

    /* ---------- social / UGC — the styled frames ---------- */
    social1: RR.styled, social2: LL.styled, social3: BB.styled,
    social4: MM.styled, social5: MK.styled, social6: EU.styled,

    /* ---------- product detail page ---------- */
    pdp1: RR.front,
    pdp2: RR.styled,
    pdp3: { src: Q + 'old-money-royal-rupee-5.webp', alt: 'Royal Rupee — Young. Refined. Magnetic.', aspect: '2:3' },
    pdp4: { src: Q + 'old-money-royal-rupee-7.webp', alt: 'Royal Rupee — crafted for him and her', aspect: '2:3' },

    /* ---------- NO REAL ASSET YET — generated plates, deliberately obvious ----------
       There is no ingredient or interior photography in the brand's library.
       These stay as art-direction plates until a shoot happens.            */
    noteBergamot:   { src: P + 'noteBergamot.svg',   alt: 'Bergamot',   art: 'Macro of bergamot peel, cool daylight, water beads, dark stone ground' },
    noteSandalwood: { src: P + 'noteSandalwood.svg', alt: 'Sandalwood', art: 'Sandalwood shavings and a cut billet, warm low side light' },
    noteOud:        { src: P + 'noteOud.svg',        alt: 'Oud',        art: 'Resinous oud chips, thin smoke, near black ground' },
    noteTobacco:    { src: P + 'noteTobacco.svg',    alt: 'Tobacco',    art: 'Cured tobacco leaf, dry texture, raking light' },
    noteVanilla:    { src: P + 'noteVanilla.svg',    alt: 'Vanilla',    art: 'Split vanilla pods, seeds visible, soft warm light' },
    noteCedar:      { src: P + 'noteCedar.svg',      alt: 'Cedar',      art: 'Cedar blocks and shavings, cool grey ground' },
    ingredients:    { src: P + 'ingredients.svg',    alt: 'Ingredients',art: 'Overhead flat lay of the raw materials on stone' },
    bottleCloseup:  { src: P + 'bottleCloseup.svg',  alt: 'Detail',     art: 'Macro of the collar and cap, single specular highlight' },
    texture:        { src: P + 'texture.svg',        alt: '',           art: 'Paper texture, neutral' }
  };
})(window);
